/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TickerAuctionCatalogPartDto } from '../../models/ticker-auction-catalog-part-dto';

export interface FindActiveTicketAuctionCatalogParts$Params {
  'X-API-Version'?: string;
}

export function findActiveTicketAuctionCatalogParts(http: HttpClient, rootUrl: string, params?: FindActiveTicketAuctionCatalogParts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>> {
  const rb = new RequestBuilder(rootUrl, findActiveTicketAuctionCatalogParts.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TickerAuctionCatalogPartDto>>;
    })
  );
}

findActiveTicketAuctionCatalogParts.PATH = '/api/ticker/auction-catalog-parts/active';
